module.exports = __webpack_public_path__ + "img/symbol_8.d9b25af9.png";